import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class PenaltyTimingRecordModel extends Model 
{
	@attr('date') time;
	@attr description;
	@attr type;
	@attr('boolean') isBonus;
	
	@belongsTo('event', {inverse: 'penaltyTimingRecords', async: true}) EventId;
	@belongsTo('entry', {inverse: 'penaltyTimingRecords', async: true}) EntryId;
}